import React, { useEffect, Component } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { App } from './App';
import ThankYou from './pages/ThankYou';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import { pageview } from './components/tracking/metaPixel';
// Component to handle route changes and track page views
const RouteChangeTracker = () => {
  const location = useLocation();
  useEffect(() => {
    // Track page view on route change
    pageview();
    // Debug info
    console.log('Tracking page view for:', location.pathname);
  }, [location]);
  return null;
};
export function AppRouter() {
  useEffect(() => {
    // No inicializamos el pixel aquí, ya se inicializa en meta-pixel.js
    // Track initial page view
    if (window.fbq) {
      pageview();
      console.log('Initial pageview tracked');
    } else {
      console.error('fbq no disponible para tracking inicial');
    }
  }, []);
  return <BrowserRouter data-id="element-15" data-mp="2903p9i1iau1w">
      <RouteChangeTracker data-id="element-16" data-mp="28zlme2kc9hl0" />
      <Routes data-id="element-17" data-mp="28yslhi829mas">
        <Route path="/" element={<App data-id="element-19" data-mp="241acxsxyh93b" />} data-id="element-18" data-mp="28yaebqjv1no3" />
        <Route path="/thank-you" element={<ThankYou data-id="element-21" data-mp="240r2examxmzb" />} data-id="element-20" data-mp="241tpsv8r17ah" />
        <Route path="/gracias.html" element={<ThankYou data-id="element-23" data-mp="2iqpvwmr8wa8g" />} data-id="element-22" data-mp="23z7imwprstss" />
        <Route path="/gracias" element={<ThankYou data-id="element-25" data-mp="2is9e4iwgovcv" />} data-id="element-24" data-mp="2iovbd9jvyk4w" />
        <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-27" data-mp="2ds4x8rrn5ym4" />} data-id="element-26" data-mp="2dr3iodbf2tzn" />
        <Route path="/privacidad" element={<PrivacyPolicy data-id="element-29" data-mp="1q199c5qb3nk5" />} data-id="element-28" data-mp="2drvf1qcu8vqz" />
        <Route path="/terms" element={<TermsOfService data-id="element-31" data-mp="1q1rejruy5c47" />} data-id="element-30" data-mp="1q2kby280mp9o" />
        <Route path="/terminos" element={<TermsOfService data-id="element-33" data-mp="1l37rtp8j3was" />} data-id="element-32" data-mp="1l2fuo9za9qie" />
      </Routes>
    </BrowserRouter>;
}